import React, { useEffect, useState } from "react";
import checkBoxResponse_icon from "../../../../Assets/checkBoxResponse_icon.svg";
import singleChoiceIcon from "../../../../Assets/singleChoiceIcon.svg";
import MultiResponse_icon from "../../../../Assets/MultiResponse_icon.svg";
import responcechoice_icon from "../../../../Assets/responcechoice_icon.svg";
import CheckBoxquestionIcon from "../../../../Assets/CheckBoxquestionIcon.svg";
import documentresponse_icon from "../../../../Assets/documentresponse_icon.svg";
import Website_Link from "../../../../Assets/Website_Link.svg";
import email_icon_Form from "../../../../Assets/email_icon_Form.svg";
import SignatureIconContainer from "../../../../Assets/SignatureIconContainer.svg";
import startquestion_icon from "../../../../Assets/startquestion_icon.svg";
import addrating_icon from "../../../../Assets/addrating_icon.svg";
import thumbsuprating_icon from "../../../../Assets/thumbsuprating_icon.svg";
import heartrating_icon from "../../../../Assets/heartrating_icon.svg";
import balloonrating_icon from "../../../../Assets/balloonrating_icon.svg";
import flagrating_icon from "../../../../Assets/flagrating_icon.svg";
import basketballrating_icon from "../../../../Assets/basketballrating_icon.svg";

import minusIcon_spinner from "../../../../Assets/minusIcon_spinner.svg";
import plusIcon_spinner from "../../../../Assets/plusIcon_spinner.svg";
import axios from "axios";
const ShortAnswer = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        >
          {/* {response.question} */}
        </div>
      </div>
      <div className="Questionview_shortAnswer">{response.placeHolder}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div
              className="AnswerText"
              // dangerouslySetInnerHTML={{ __html: answer.question }}
            >
              {answer.answer}
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const Location = ({ response, index }) => { 
  console.log(response);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="address-container">
        {response.address?.map(
          (address, i) =>
            address.type === "address" && (
              <div className="addresslineone" key={i}>
                <p>{address.placeHolder}</p>
              </div>
            )
        )}
        <div className="other-details-container">
          {response.address?.map(
            (address, i) =>
              address.type === "text" && (
                <div className="addresslineone" key={i}>
                  <p>{address.placeHolder}</p>
                </div>
              )
          )}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses?.map((address, i) => (
          <div className="Answer_container">
            <div className="responceCount">Response {i + 1}</div>
            <div
              className="address-container"
              style={{
                backgroundColor: "rgba(27, 81, 187, 0.04)",
                borderRadius: "9px",
                padding: "0.8rem 1rem",
                marginTop: "5px",
              }}
            >
              {address.answer?.map(
                (address, i) =>
                  address.type === "address" && (
                    <div
                      className="addresslineone"
                      key={i}
                      style={{
                        backgroundColor: "#ffffff",
                        padding: "1rem",
                      }}
                    >
                      <p style={{ color: "#1B2436", fontSize: "0.9rem" }}>
                        {address.value}
                      </p>
                    </div>
                  )
              )}
              <div className="other-details-container">
                {address.answer?.map(
                  (address, i) =>
                    address.type === "text" && (
                      <div
                        className="addresslineone"
                        key={i}
                        style={{ backgroundColor: "#ffffff", padding: "1rem" }}
                      >
                        <p style={{ color: "#1B2436", fontSize: "0.9rem" }}>
                          {address.value}
                        </p>
                      </div>
                    )
                )}
              </div>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};
const ParagraphAnswer = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        >
          {/* {response.question} */}
        </div>
      </div>
      <div className="Questionview_shortAnswer">{response.placeHolder}</div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="AnswerText">{answer.answer}</div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};
const MultipleChoice = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="questionView_OPtionContainer">
        {response.options.map((option, i) => (
          <div className="question_response_choice" key={i}>
            <img src={singleChoiceIcon} alt="singleChoiceIcon" />
            <div className="">{option.optionText}</div>
          </div>
        ))}
      </div>
      {response.responses.map((answer, i) => (
        <div className="Answer_container" key={i}>
          <div className="responceCount">Response {i + 1}</div>
          <div className="chose_AnswerText">
            <img src={checkBoxResponse_icon} alt="checkBoxResponse_icon" />
            {answer.answer}
          </div>
          {i !== response.responses.length - 1 && <hr />}
        </div>
      ))}
    </div>
  );
};

const CheckBox = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{response.question}</div>
      </div>
      <div className="questionView_OPtionContainer">
        {response.options.map((option, i) => (
          <div className="question_response_choice">
            <img src={singleChoiceIcon} alt="singleChoiceIcon" />
            <div>{option.optionText}</div>
          </div>
        ))}
      </div>
      {response.responses.map((answer, i) => (
        <div className="Answer_container" key={i}>
          <div className="responceCount">Response {i + 1}</div>
          <div className="choice_AnswerText">
            {answer.answer.map((text, i) => (
              <div
                style={{
                  display: "flex",
                  gap: "0.625rem",
                }}
                key={i}
              >
                <img src={MultiResponse_icon} alt="MultiResponse_icon" />
                <p>{text}</p>
              </div>
            ))}
          </div>
          {i !== response.responses.length - 1 && <hr />}
        </div>
      ))}
    </div>
  );
};

const CheckBoxImage = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{response.question}</div>
      </div>
      <div className="imageQuestion_">
        {response.options.map((option, i) => (
          <div className="question_response_choice" key={i}>
            <img src={singleChoiceIcon} alt="singleChoiceIcon" />
            <div>{option.optionText}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

const LineScale = ({ response, index }) => {
  console.log(response);
  const divs = [];

  for (let i = response.minRange.value; i <= response.maxRange.value; i++) {
    divs.push(
      <div className="linescale_container">
        <div>{i}</div>
        <div>
          <img src={responcechoice_icon} alt="responcechoice_icon" />
        </div>
      </div>
    );
  }
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="Line_scale">
        <div>{response.maxRange.labelName}</div>
        {divs}
        <div>{response.minRange.labelName}</div>
      </div>
      {response.responses.map((answer, i) => (
        <div className="Answer_container" key={i}>
          <div className="responceCount">Response {i + 1}</div>
          <div className="chose_AnswerText">
            <img src={checkBoxResponse_icon} alt="checkBoxResponse_icon" />
            {answer.answer}
          </div>
          {i !== response.responses.length - 1 && <hr />}
        </div>
      ))}
    </div>
  );
};

const GridBox = ({ response, index }) => {
  const [selectedRow, setSelectedRow] = useState(response.row[0].rowText); // Initially select the first row

  const [selectedRowAnswers, setSelectedRowAnswers] = useState([]); // Store the answers for the selected row

  // Function to handle the row click
  const handleRowClick = (rowText) => {
    setSelectedRow(rowText);

    // Find answers for the clicked row
    const answersForRow = response.responses.map((response) => {
      const answerForRow = response.answer.find(
        (answer) => answer.rowText === rowText
      );
      return answerForRow ? answerForRow.value : null;
    });

    setSelectedRowAnswers(answersForRow);
  };
  return (
    <>
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: response.question }}
          ></div>
        </div>
        <table>
          <thead>
            <tr>
              <th></th>
              {response.column.map((column, colIndex) => (
                <th key={colIndex}>{column.columnText}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {response.row.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => handleRowClick(row.rowText)}
                style={{
                  background:
                    row.rowText === selectedRow
                      ? "rgba(27, 81, 187, 0.05)"
                      : "none",
                  borderRadius: row.rowText === selectedRow ? "0.5rem" : 0,
                }}
              >
                <td>{row.rowText}</td>
                {response.column.map((column, colIndex) => (
                  <td key={colIndex}>
                    <div className="cell-content">
                      <img src={singleChoiceIcon} alt="singleChoiceIcon" />
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>

        {selectedRowAnswers.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="chose_AnswerText">
              <img src={checkBoxResponse_icon} alt="checkBoxResponse_icon" />
              {answer}
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </>
  );
};

const CheckBoxGrid = ({ response, index }) => {
  const [selectedRow, setSelectedRow] = useState(response.row[0].rowText);
  const [selectedRowAnswers, setSelectedRowAnswers] = useState([]);

  console.log(selectedRow);
  // Function to handle the row click
  const handleRowClick = (rowText) => {
    setSelectedRow(rowText);

    // Find answers for the clicked row
    const answersForRow = response.responses.map((response) => {
      const answerForRow = response.answer.filter(
        (answer) => answer.rowText === rowText
      );
      return answerForRow.map((answer) => answer.values); // Map to extract all values for the selected row
    });

    setSelectedRowAnswers(answersForRow);
  };

  // useEffect to initialize selectedRowAnswers when component mounts
  useEffect(() => {
    // Initially set the answers for the first row
    const initialAnswers = response.responses.map((response) => {
      const answerForRow = response.answer.filter(
        (answer) => answer.rowText === selectedRow
      );
      return answerForRow.map((answer) => answer.values); // Map to extract all values for the selected row
    });

    setSelectedRowAnswers(initialAnswers); // Set the initial answers for the first row
  }, [response, selectedRow]); // This runs when the response or selectedRow changes

  return (
    <>
      <div className="ShortAnswer_container">
        <div className="Questionview_container">
          {index + 1}.
          <div
            className="Questionview_text"
            dangerouslySetInnerHTML={{ __html: response.question }}
          ></div>
        </div>
        <table>
          <thead>
            <tr>
              <th></th>
              {response.column.map((column, colIndex) => (
                <th key={colIndex}>{column.columnText}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {response.row.map((row, rowIndex) => (
              <tr
                key={rowIndex}
                onClick={() => handleRowClick(row.rowText)}
                style={{
                  background:
                    row.rowText === selectedRow
                      ? "rgba(27, 81, 187, 0.05)"
                      : "none",
                  borderRadius: row.rowText === selectedRow ? "0.5rem" : 0,
                }}
              >
                <td>{row.rowText}</td>
                {response.column.map((column, colIndex) => (
                  <td key={colIndex}>
                    <div className="cell-content">
                      <img
                        src={CheckBoxquestionIcon}
                        alt="CheckBoxquestionIcon"
                      />
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
        {console.log(selectedRowAnswers)}
        {selectedRowAnswers.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="choice_AnswerText">
              {answer[0].map((text) => (
                <div
                  style={{
                    display: "flex",
                    gap: "0.625rem",
                  }}
                >
                  <img src={MultiResponse_icon} alt="MultiResponse_icon" />
                  {console.log(text)}
                  <p>{text}</p>
                </div>
              ))}
            </div>
            {/* {i !== response.answers.length - 1 && <hr />}  */}
          </div>
        ))}
      </div>
    </>
  );
};

const Document = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{response.question}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.answers.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="AnswerText">
              <p className="TextWPic">
                <img src={documentresponse_icon} alt="documentresponse_icon" />
                {answer.file}
              </p>
            </div>
            {i !== response.answers.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const Name = ({ response, index }) => {
  console.log(response.responses);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="nameAns_container">
        <div className="Name">{response.firstName}</div>
        <div className="Name">{response.lastName}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="NameQuestion">
              {console.log(answer.answer.firstName)}
              <p>{answer.answer.firstName}</p>
              <p>{answer.answer.lastName}</p>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};
const Website = ({ response, index }) => {
  console.log(response);
  const formatUrl = (url) => {
    return url.startsWith("http://") || url.startsWith("https://")
      ? url
      : `https://${url}`;
  };
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{response.question}</div>
      </div>
      <div className="nameAns_container">
        <div className="Name" style={{ display: "flex", gap: "0.5rem" }}>
          <img src={Website_Link} alt="Website_Link" />
          {response.placeHolder}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="AnswerText">
              <p className="TextWPic">
                <img src={Website_Link} alt="Website_Link" />
                {response.answer === "No Responses" ? (
                  <p className="website_link">No Responses</p>
                ) : (
                  <a
                    href={formatUrl(answer.answer)}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="website_link"
                  >
                    {answer.answer}
                  </a>
                )}
              </p>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const Email = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="nameAns_container">
        <div className="Name" style={{ display: "flex", gap: "0.5rem" }}>
          <img src={email_icon_Form} alt="email_icon_Form" />
          {response.placeHolder}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="AnswerText">
              <p className="TextWPic">
                <img src={email_icon_Form} alt="email_icon_Form" />
                {answer.answer}
              </p>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const Signature = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div
        class="container"
        style={{
          width: `${response.boxWidth}px`,
          height: `${response.boxHeight}px`,
          minWidth: "45%",
          minHeight: "12.2rem",
          maxWidth: "90%",
          maxHeight: "22rem",
        }}
      >
        <div class="content">
          <img src={SignatureIconContainer} alt="SignatureIconContainer" />
          <p>Signature</p>
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="AnswerText">
              <p className="TextWPic">
                <img src={answer.answer} alt="email_icon_Form" />
              </p>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const VAFileUpload = ({ response, index }) => {
  const handleGetFile = async (fileKey) => {
    const Url = process.env.REACT_APP_API;
    console.log(fileKey);
    try {
      // Replace this with your actual API endpoint to get the signed URL
      const response = await axios.post(`${Url}/forms/retrieve`, { fileKey });

      console.log(response.data);
      if (response.data.success) {
        // Trigger the download
        const downloadUrl = response.data.url;
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileKey.split("/").pop(); // Set the download filename
        a.click();
      } else {
        alert("Failed to fetch the file URL.");
      }
    } catch (error) {
      console.error("Error getting signed URL", error);
    }
  };
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div
              className="AnswerText"
              style={{ flexDirection: "column", gap: "1rem" }}
            >
              {answer.answer.map((file, i) => (
                <p
                  className="TextWPic"
                  style={{ justifyContent: "start", cursor: "pointer" }}
                  key={i}
                  onClick={() => handleGetFile(file[0].fileKey)}
                >
                  <img
                    src={documentresponse_icon}
                    alt="documentresponse_icon"
                  />
                  {file[0].fileName}
                </p>
              ))}
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const FileUpload = ({ response, index }) => {
  const handleGetFile = async (fileKey) => {
    const Url = process.env.REACT_APP_API;
    console.log(fileKey);
    try {
      // Replace this with your actual API endpoint to get the signed URL
      const response = await axios.post(`${Url}/forms/retrieve`, { fileKey });

      console.log(response.data);
      if (response.data.success) {
        // Trigger the download
        const downloadUrl = response.data.url;
        const a = document.createElement("a");
        a.href = downloadUrl;
        a.download = fileKey.split("/").pop(); // Set the download filename
        a.click();
      } else {
        alert("Failed to fetch the file URL.");
      }
    } catch (error) {
      console.error("Error getting signed URL", error);
    }
  };
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div
              className="AnswerText"
              style={{ flexDirection: "column", gap: "1rem" }}
            >
              {answer.answer.map((file, i) => (
                <p
                  className="TextWPic"
                  style={{ justifyContent: "start", cursor: "pointer" }}
                  key={i}
                  onClick={() => handleGetFile(file[0].fileKey)}
                >
                  <img
                    src={documentresponse_icon}
                    alt="documentresponse_icon"
                  />
                  {file[0].fileName}
                </p>
              ))}
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};
const Phone = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="nameAns_container">
        <div className="number_Name">
          <p>+91</p>
          {response.placeHolder}
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="NameQuestion">
              +91<p>{answer.answer}</p>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};
const Number = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="nameAns_container">
        <div className="number_Name">{response.placeHolder}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="NameQuestion">
              <p>{answer.answer}</p>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const images = {
  star: startquestion_icon,
  balloon: balloonrating_icon,
  addIcon: addrating_icon,
  thumbsup: thumbsuprating_icon,
  heart: heartrating_icon,
  flag: flagrating_icon,
  basketball: basketballrating_icon,
  // Add other types and their images here
};
const Ratings = ({ response, index }) => {
  const imageSrc = images[response.typeofdign];

  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{response.question}</div>
      </div>
      <div className="ratingimg_container">
        {Array.from({ length: response.count }).map((_, index) => (
          <img key={index} src={imageSrc} alt={imageSrc} />
        ))}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.answers.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="chose_AnswerText">
              <img src={checkBoxResponse_icon} alt="checkBoxResponse_icon" />
              {answer.rating}
            </div>
            {i !== response.answers.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};
const DateAndTime = ({ response, index }) => {
  console.log(response);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{response.question}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="datetime_container">
              <div className="appDate-container">
                <div className="date-container">
                  <div key={index} className="dateandtime-container">
                    {/* {console.log(answer.answer)} */}
                    <div className="">{answer.answer.date}</div>
                  </div>
                </div>
                <div className="vertical-line"></div>
                <div className="month-year-container">
                  <div key={index} className="time-container">
                    <div className="time_container">{answer.answer.time}</div>
                  </div>
                </div>
              </div>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const Spinner = ({ response, index }) => {
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="nameAns_container">
        <div
          className="Name"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingRight: "0.6rem",
          }}
        >
          <img src={minusIcon_spinner} alt="minusIcon_spinner" />
          {/* <p sty>{question.answer}</p> */}
          <img src={plusIcon_spinner} alt="plusIcon_spinner" />
        </div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="NameQuestion">
              <p>{answer.answer}</p>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

const Dropdown = ({ response, index }) => {
  console.log(response);
  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.
        <div
          className="Questionview_text"
          dangerouslySetInnerHTML={{ __html: response.question }}
        ></div>
      </div>
      <div className="questionView_OPtionContainer">
        {response.options.map((option, i) => (
          <div className="question_response_choice" key={i}>
            <div>{i + 1}. </div>
            <div className="">{option.optionText}</div>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="NameQuestion">
              <p>{answer.answer}</p>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};
const Date = ({ response, index }) => {
  // Function to format date
  const formatDate = (dateString, format) => {
    // Split the input date and format strings
    const dateParts = dateString.split("-");
    const formatParts =
      format === "" ? "year-month-date".split("-") : format.split("-");
    console.log(dateParts, formatParts, format);
    // Map the parts to their respective names
    const day = dateParts[formatParts.indexOf("date")];
    const month = dateParts[formatParts.indexOf("month")];
    const year = dateParts[formatParts.indexOf("year")];

    return { day, month, year };
  };

  return (
    <div className="ShortAnswer_container">
      <div className="Questionview_container">
        {index + 1}.<div className="Questionview_text">{response.question}</div>
      </div>
      <div style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}>
        {response.responses.map((answer, i) => (
          <div className="Answer_container" key={i}>
            <div className="responceCount">Response {i + 1}</div>
            <div className="datetime_container">
              <div className="appDate-container">
                <div className="date-container">
                  <div key={index} className="date-item">
                    <div className="day">
                      {formatDate(answer.answer, response.dateFormat).day}
                    </div>
                  </div>
                </div>
                <div className="vertical-line"></div>
                <div className="month-year-container">
                  <div key={index} className="time-container">
                    {formatDate(answer.answer, response.dateFormat).month}/
                    {formatDate(answer.answer, response.dateFormat).year}
                  </div>
                </div>
              </div>
            </div>
            {i !== response.responses.length - 1 && <hr />}
          </div>
        ))}
      </div>
    </div>
  );
};

export {
  VAFileUpload,
  ShortAnswer,
  ParagraphAnswer,
  MultipleChoice,
  CheckBox,
  CheckBoxImage,
  LineScale,
  GridBox,
  CheckBoxGrid,
  Document,
  Name,
  Website,
  Email,
  Signature,
  Phone,
  Ratings,
  DateAndTime,
  Date,
  Number,
  Spinner,
  FileUpload,
  Dropdown,
  Location,
};
